import { createAsyncThunk } from '@reduxjs/toolkit';
import { 
    getResultTagList, 
    addAnalouePlot, 
    getGridColumnsData , 
    getAllAnaloguePlotList, 
    removeAFPlot, 
    getBroadFilterParameter, 
    addBroadFilterParameter, 
    deleteBroadFilterParameter,  
    resetBroadFilterParameter,
    getAllAnalogueSettingTags,
    updateAnalogueSelection
} from 'api/analogue';
import { R_getAnalogueePlottingData, IScoringParameterDetail } from '../../api/GridData/gridData';
import { checkAndHandleReadOnlyAccess } from 'helpers/functions/workspaceHelpers';
import { IWorkspaceItem } from 'store/workspace/types';

export const getAllAnalogueSettingTagsThunk = createAsyncThunk('analogueWorkSpace/getAllAnalogueSettingTags', async(thunkAPI) => {
    const response = await getAllAnalogueSettingTags(thunkAPI);
    return response;
});

export const addNewAnalougePlot = createAsyncThunk('analogueWorkSpace/add', async(data: {workspaceId: string, title: string}, thunkAPI) => {
    // Check read-only access before adding analogue plot
    const state = thunkAPI.getState() as any;
    const currentWorkspace = state.workspaceSlice.workspaces.find((ws: IWorkspaceItem) => ws.id === data.workspaceId);
    const currentUserId = state.userStateSlice.id;
    
    if (checkAndHandleReadOnlyAccess(currentWorkspace, currentUserId, thunkAPI.dispatch)) {
        return thunkAPI.rejectWithValue('Read-only workspace');
    }
    
    const response = await addAnalouePlot(data, thunkAPI);
    return response;
});

export const getAllAnaloguePlotListThunk = createAsyncThunk('analogueWorkSpace/getAllList', async(workspaceId: string, thunkAPI) => {
    const response = await getAllAnaloguePlotList(workspaceId, thunkAPI);
    return response;
});

export const removeAnaloguePlotThunk = createAsyncThunk('analogueWorkSpace/removeAnalogueWorkSpace', async(id: string, thunkAPI) => {
    // Check read-only access before removing analogue plot
    const state = thunkAPI.getState() as any;
    const workspaceId = state.workspaceSlice.workspaceId;
    const currentWorkspace = state.workspaceSlice.workspaces.find((ws: IWorkspaceItem) => ws.id === workspaceId);
    const currentUserId = state.userStateSlice.id;
    
    if (checkAndHandleReadOnlyAccess(currentWorkspace, currentUserId, thunkAPI.dispatch)) {
        return thunkAPI.rejectWithValue('Read-only workspace');
    }
    
    const response = await removeAFPlot(id, thunkAPI);
    return response;
});

export const getBroadFilterParameterThunk = createAsyncThunk('analogueWorkSpace/getBroadFilterParameter', async(id: string, thunkAPI) => {
    const response = await getBroadFilterParameter(id, thunkAPI);
    return response;
});

export const addBroadFilterParameterThunk = createAsyncThunk('analogueWorkSpace/addBroadFilterParameter', async(data: {itemId: string, workSpaceId: string}, thunkAPI) => {
    const response = await addBroadFilterParameter(data, thunkAPI);
    return response;
});

export const deleteBroadFilterParameterThunk = createAsyncThunk('analogueWorkSpace/deleteBroadFilterParameter', async(data: {id: string, workSpaceId: string}, thunkAPI) => {
    const response = await deleteBroadFilterParameter(data, thunkAPI);
    return response;
});

export const resetBroadFilterParameterThunk = createAsyncThunk('analogueWorkSpace/resetBroadFilterParameter', async(thunkAPI) => {
    const response = await resetBroadFilterParameter(thunkAPI);
    return response;
});

export const getResultTagListThunk = createAsyncThunk('analogueWorkSpace/getResultTagList', async(thunkAPI) => {
    const response = await getResultTagList(thunkAPI);
    return response;
});

export const getGridColumnsDataThunk = createAsyncThunk('analogueWorkSpace/getGridColumnData', async(data: {id: string,  columns: string[]}, thunkAPI) => {
    const response = await getGridColumnsData(data, thunkAPI);
    return response;
});

// New thunk for getting analogue plotting data with scoring parameter filtering
export const getAnalogueePlottingDataThunk = createAsyncThunk(
  'analogue/getPlottingData',
  async (data: { 
    workspaceId: string, 
    plotId: string, 
    plotType: 'crossplot' | 'histogram',
    xTagAttributeId?: string,
    yTagAttributeId?: string,
    broadParameterTagAttributeIds?: string[],
    scoringParameters?: IScoringParameterDetail[],
    filterOptions?: any[]
  }, thunkAPI) => {
    try {
      const response = await R_getAnalogueePlottingData(data, thunkAPI);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateAnalogueSelectionThunk = createAsyncThunk(
  'analogueWorkSpace/updateSelection', 
  async (analoguePlotId: string, thunkAPI) => {
    const response = await updateAnalogueSelection(analoguePlotId, thunkAPI);
    return response;
  }
);